<template>
<div id="landing-page">

  <!-- <v-toolbar class="white">
       <v-toolbar-title v-text="title"></v-toolbar-title>
  </v-toolbar> -->
  <VtoolBarLandingPage></VtoolBarLandingPage>

  <SideBarLanding></SideBarLanding>

  <v-content>
    <section id="section1" color="light-blue">
      <v-img
        :src="require('../assets/PNG/people-faces-fs8.png')"
        class="wave"
        height="100%"
      >
        <v-container>
          <v-layout row wrap height="100vh">

              <v-card flat class="transparent">
                <v-card-text>
                  <v-layout justify-center align-center>
                    <v-img :src="require('../assets/fuzzcv-logo.png')"
                           max-width="500px"
                           contain
                           class="mb-2 mt-5 pt-5 text-xs-center"
                           alt="fuzzcv curriculum vitae CV automatique en ligne logo"
                    />
                  </v-layout>
                </v-card-text>

                <v-card-text>
                  <h1 class="font-weight-bold my-5 white--text" :style="{'font-size': fontSizeTitle1}">{{ underTitle }}</h1>
                  <transition appear name="mytrans">
                    <div>
                      <h2 class="font-weight-medium white--text" :style="{'font-size': fontSizeTitle2}">{{ title2 }}</h2>
                      <div class="my-5">
                        <h3 class="white--text thetext" :style="{'font-size': fontSizeTitle3}">{{ subtitle2 }} </h3>
                      </div>

                      <!-- <subscribeClosed/> -->
                      <div class="mt-4 text-xs-center">
                        <v-btn large round
                               color="success"
                               to='/register'
                        >
                          {{ signup }}
                        </v-btn>
                      </div>
                    </div>
                  </transition>
                </v-card-text>
              </v-card>
          </v-layout>
        </v-container>
      </v-img>
    </section>

    <section id="section2">
      <v-layout
        column
        wrap
        align-center
      >
        <v-flex xs12>
          <v-container grid-list-xl>
            <v-layout align-start justify-center row wrap fill-height>
              <v-flex xs12 md4>
                <v-card flat class="transparent">
                  <v-card-text class="text-xs-center">
                    <v-img
                      :src="require('../assets/ICONS/contract-blue.png')"
                      height="100px"
                      contain
                    >
                    </v-img>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <h4 class="headline text-xs-center black--text">{{ howItWorkTitle1 }}</h4>
                  </v-card-title>
                  <v-card-text class="text-xs-center black--text">
                    <p class="thetext">{{ howItWorkContent1 }}</p>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card flat class="transparent">
                  <v-card-text class="text-xs-center">
                    <v-img
                      :src="require('../assets/ICONS/layout-blue.png')"
                      height="100px"
                      contain
                    >
                    </v-img>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <h4 class="headline text-xs-center black--text">{{ howItWorkTitle2 }}</h4>
                  </v-card-title>
                  <v-card-text class="text-xs-center black--text">
                    <p class="thetext">{{ howItWorkContent2 }}</p>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card flat class="transparent">
                  <v-card-text class="text-xs-center">
                    <v-img
                      :src="require('../assets/ICONS/pdf-book-blue.png')"
                      height="100px"
                      contain
                    >
                    </v-img>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <h4 class="headline text-xs-center black--text">{{ howItWorkTitle3 }}</h4>
                  </v-card-title>
                  <v-card-text class="text-xs-center black--text">
                    <p class="thetext">{{ howItWorkContent3 }}</p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section id="section3">
      <v-container>
        <carousel
          :perPage=1
          :perPageCustom="[[600, 2], [1264, 3]]"
          :navigationEnabled=true
          navigationNextLabel=""
          navigationPrevLabel=""
          paginationColor="#d8d8d8"
          paginationActiveColor="#00d1b2"
          :paginationSize=25
          :autoplay=true
          :loop=true
          :autoplayTimeout=4000
        >
          <slide
            v-for="(item, index) in templatesImgs" :key="index"
          >
            <v-card height="660px" max-height="750" elevation=8 class="ma-2">
              <v-responsive :aspect-ratio="0.8">
                <v-card-title primary-title class="justify-center amber lighten-1 white--text">
                  <h3 class="headline mb-2 pl-2">{{ item.name }}</h3>
                </v-card-title>
                <v-divider :key="index"></v-divider>
                <v-img
                  :src="getImgUrl(item.filepng)"
                  contain
                  alt="fuzzcv curriculum vitae CV automatique en ligne"
                ></v-img>
                <v-card-actions>
                </v-card-actions>
              </v-responsive>
            </v-card>
          </slide>
        </carousel>
      </v-container>
    </section>

    <!-- <section id="section4">
         <v-container>

         <swiper :options="swiperOption">
         <swiper-slide
         v-for="(item, index) in templatesImgs" :key="index"
         >
         <v-card height="600px" elevation=8>
         <v-responsive :aspect-ratio="0.8">
         <v-card-title primary-title class="justify-center amber lighten-1 white--text">
         <h3 class="headline mb-2 pl-2">{{ item.name }}</h3>
         </v-card-title>
         <v-divider :key="index"></v-divider>
         <v-img
         :src="getImgUrl(item.file)"
         contains
         alt="fuzzcv curriculum vitae CV automatique en ligne"
         ></v-img>
         <v-card-actions>
         </v-card-actions>
         </v-responsive>
         </v-card>
         </swiper-slide>
         <div class="swiper-button-prev" slot="button-prev"></div>
         <div class="swiper-button-next" slot="button-next"></div>
         <div class="swiper-pagination" slot="pagination"></div>
         </swiper>
         </v-container>

         </section> -->



    <section class="grey darken-2">
      <v-img
             :src="require('../assets/woman-handshake2-opti.jpg')"
             min-height="500px"
             alt="fuzzcv curriculum vitae CV automatique en ligne inscrire"
      >
        <v-layout column align-center justify-center fill-height>
          <h2 class="display-1 font-weight-medium white--text mb-3 text-xs-center">{{ title3 }}</h2>
          <v-btn large round
                 color="success"
                 to='/register'
          >
            {{ signup }}
          </v-btn>
          <div class="pt-5 mt-5">

            <v-btn large round
                   color="primary"
                   to='/conseils'
            >
            {{ advices }}
            </v-btn>
          </div>
        </v-layout>
      </v-img>
    </section>


    <v-footer
      class="grey darken-2"
      height="auto"
    >
      <v-layout row wrap align-center justify-center>
        <MailClient></MailClient>
        <v-btn
          flat
          color="white"
          to="/cgu"
        >
          Conditions générales d'utilisation
        </v-btn>
        <v-flex xs12 text-xs-center py-3>
          <span class="white--text ml-1 subheading">&copy; - 2019 <strong>fuzzcv.com</strong></span>
        </v-flex>
      </v-layout>
    </v-footer>

    <v-dialog
      v-model="gratisDialog"
      width="450"
    >
      <v-card elevation=20 class="vcard-round">
        <v-card-title
          primary-title
          class="success justify-center pb-0"
        >
          <v-img
            :src="require('../assets/PNG/fuzzcv-free.png')"
            height="100px"
            contain
          >
          </v-img>
        </v-card-title>
        <v-card-title
          primary-title
          class="headline white--text success font-weight-bold justify-center"
        >
          {{ gratisTitle }}
        </v-card-title>

        <v-card-text
          class="subheading font-weight-medium"
        >
          <p class="justifyit"> {{ gratisText }} </p>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            class="text-xs-center"
            color="primary"
            @click="gratisDialog = false"
          >
            continuer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-content>

  <cookie-law
    :message="cookieMessage"
    :buttonText="cookieButton"
  >
  </cookie-law>




</div>
</template>

<script>


 import VtoolBarLandingPage from '../components/VtoolBarLandingPage';
 import SubscribeClosed from '../components/SubscribeClosed';
 import MailClient from '../components/MailClient';
 import CookieLaw from 'vue-cookie-law'
 import { Carousel, Slide } from 'vue-carousel';
 import SideBarLanding from '../components/SideBarLanding';

 /* import 'swiper/dist/css/swiper.css';
  * import { swiper, swiperSlide } from 'vue-awesome-swiper'; */

 export default {
   components: {
     VtoolBarLandingPage,
     SubscribeClosed,
     MailClient,
     CookieLaw,
     Carousel,
     Slide,
     SideBarLanding,
     /* swiper,
      * swiperSlide, */
   },
   mounted: function() {
     console.log('mounted')
     setTimeout(() => {
       // switch à true pour afficher
       // le bandreau de gratuité
       this.gratisDialog = false
     }, 6000)

   },
   data() {
     return {
       title: "Next CV",
       showTransition: false,
       macImg: 'ecran-mac.png',
       frontPics: [
         {
           src: 'PNG/fuzzcv-cv-curriculum-vitae-business-girl.png'
         },
         {
           src: 'PNG/fuzzcv-cv-curriculum-vitae-cook.png'
         },
         {
           src: 'PNG/fuzzcv-cv-curriculum-vitae-worker.png'
         },
       ],
       mainTitle: `FuzzCV`,
       underTitle: `Créez gratuitement votre CV`,
       title2: `Réaliser un Curricucum Vitae est le premier pas vers votre futur emploi !`,
       subtitle2: `FuzzCV vous accompagne dans la réalisation de Curriculum Vitae avec des modèles efficaces et pertinents.
                  Vous renseignez le contenu, FuzzCV s’occupe automatiquement de la mise en forme de votre CV et le fournit au format PDF.`,
       howItWorkTitle1: `Renseigner le contenu de votre CV`,
       howItWorkContent1: `Avec FuzzCV renseignez vos informations personnelles ainsi que les rubriques importantes pour vous
                          présenter : souhaits professionnels, compétences, expériences professionnelles, parcours de formation.`,
       howItWorkTitle2: `Choisir le format de CV qui vous convient`,
       howItWorkContent2: `Vous choisissez l'apparence de votre Curriculum Vitae grâce aux différents modèles proposés par FuzzCV.
                          A tout moment changez de modèle et prévisualisez l'apparence de votre futur CV : FuzzCV s'occupe de la mise en page.`,
       howItWorkTitle3: `Télécharger votre CV au format PDF`,
       howItWorkContent3: `Lorsque vous êtes satisfait de l'apparence de votre Curriculum Vitae, vous pouvez le télécharger sur votre ordinateur
                          ou votre smartphone. Vous disposez ainsi d'un CV au format PDF facilement joignable à un mail de candidature
                          ou imprimable afin d’accompagner votre lettre de motivation.`,
       title3: `Réalisez votre Curriculum Vitae n'a jamais été aussi facile`,
       signup: `réalisez votre CV`,
       advices: `Nos conseils pour réaliser un Curriculum Vitae efficace`,
       cookieMessage: `Nous utilisons des cookies pour le bon fonctionnement du site ainsi que pour  nous permettre de mieux comprendre comment le site est utilisé. En continuant à utiliser ce site, vous acceptez cette politique.`,
       cookieButton: "J'ai compris",

       templatesImgs: [
         { name: 'CV Classique', filewebp: 'PNG/templates/template1.webp', filepng: 'PNG/templates/template1-fs8.png' },
         { name: 'CV Dynamique', filewebp: 'PNG/templates/template2.webp', filepng: 'PNG/templates/template2-fs8.png' },
         { name: 'CV Performant', filewebp: 'PNG/templates/template3.webp', filepng: 'PNG/templates/template3-fs8.png' },
       ],
       swiperOption: {
         // options pour surmon-china/vue-awesome-swiper
         slidesPerView: 3,
         centerInsufficientSlides: true,
         // spaceBetween: 30,
         // slidesOffsetBefore: 40,
         // slidesOffsetAfter: 40,
         pagination: {
           el: '.swiper-pagination',
           // type: 'progressbar',
           clickable: true
         },
         navigation: {
           nextEl: '.swiper-button-next',
           prevEl: '.swiper-button-prev'
         },
         watchOverflow: true,
         breakpointsInverse: true,
         breakpoints: {
           // when window width is >= 320px
           0: {
             slidesPerView: 1,
             spaceBetween: 0,
           },
           // when window width is >= 480px
           960: {
             slidesPerView: 2,
             spaceBetween: 30
           },
           // when window width is >= 640px
           1264: {
             slidesPerView: 3,
             spaceBetween: 30
           }
         },
       },
       gratisDialog: false,
       gratisTitle: "FuzzCv est GRATUIT!",
       gratisText: `Pour son lancement, toutes les fonctionnalités de FuzzCV vous sont
         offertes gratuitement, alors n'hésitez pas, inscrivez vous et commencez votre CV!`

     };
   },
   computed: {
     fontSizeTitle1() {
       console.log(this.$vuetify.breakpoint.name)
       switch (this.$vuetify.breakpoint.name) {
         case 'xs': return '3em';
         case 'sm': return '4em';
         default: return '5em';
       }
     },
     fontSizeTitle2() {
       console.log(this.$vuetify.breakpoint.name)
       switch (this.$vuetify.breakpoint.name) {
         case 'xs': return '2.2em';
         case 'sm': return '2em';
         default: return '3em';
       }
     },
     fontSizeTitle3() {
       console.log(this.$vuetify.breakpoint.name)
       switch (this.$vuetify.breakpoint.name) {
         case 'xs': return '1.3em';
         case 'sm': return '1.5em';
         default: return '2em';
       }
     },
   },
   methods: {
     getImgUrl(pic) {
       var thepath = '../assets/'+ pic;
       console.log("Chemin de la pic : " + thepath);
       return require('../assets/'+pic);
     }
   }

 };
</script>

<style>
 .list-item-enter, .list-item-leave-to /* .list-leave-active for <2.1.8 */ {
     transition: all 1.5s ease;
     opacity: 0;
     transform: scale(0.5);
 }

 .list-item-move {
     transition: transform 1s;
 }

 .list-item-enter-active, .list-item-leave-active {
     transition: all 1.5s ease-in-out ;
     transition: opacity 0.3s, transform 0.3s;
     transform-origin: left center;
 }

 .tray-enter,
 .tray-leave-to {
     opacity: 0;
     transition:4s }

 .tray-leave,
 .tray-enter-to { opacity: 1;
     transition:4s }

 .fade-transition {
     transition: all 2s ease-in-out;
 }





 .fadeOne-enter-active, .fadeOne-leave-active {
     transition: all 1.5s ease;
 }
 .fadeOne-enter, .fadeOne-leave-to {

     transform: translate(0%, 100%);
 }

 .mytrans-enter-active {
     /* all : la transition est pour toute les transformations,

        ease : Rapide sur le début et ralenti sur la fin.
        linear : La vitesse est constante sur toute la durée de l'animation.
        ease-in : Lent sur le début et accélère de plus en plus vers la fin.
        ease-out : Rapide sur le début et décèlere sur la fin.
        ease-in-out : Le départ et la fin sont lents.
      */
     transition:  all 1.5s ease;
 }
 .mytrans-enter {
     transform: translate(0%, 100%);
     opacity: 0;
 }

 /* .fade-enter-active .fade-leave-active .fade-leave-to {
    transition:  all 3s ease;
    }
    .fade-enter .fade-leave .fade-leave-to {
    opacity: 0;
    } */

 .fade-transition-enter-active .fade-transition-leave-active .fade-transition-leave-to {
     transition:  all 1.5s ease;
 }

 .thetext {
     text-align: justify;
     text-justify: inter-character;
 }

 .justifyit {
     text-align: justify;
     text-justify: inter-word;
 }

 .swiper-pagination-bullet {
     width: 20px;
     height: 20px;
 }
 .swiper-button-prev {
     left: 0 !important;
     /* background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%234c71ae'%2F%3E%3C%2Fsvg%3E") !important; */
 }
 .swiper-button-next {
     right: 0 !important;
     /* background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%234c71ae'%2F%3E%3C%2Fsvg%3E") !important; */
 }

 .vcard-round {
     border-radius:50px;
     /* border-top: 5px solid;
        border-color: blue !important; */
 }

 /* .vcard-border-color-top {
    border-top: 5px solid;
    border-top-color: blue;
    }

    .vcard-border-color-bottom {
    border-bottom: 5px solid;
    border-bottom-color: blue;
    }

    .vcard-border-color-side {
    border-left: 5px solid;
    border-right: 5px solid;
    border-left-color: blue;
    border-right-color: blue;
    } */
 /* .frontimg {
    opacity: 0.5;
    filter: alpha(opacity=50);
    background: black;
    } */

 #section1 {
     background-color: #01579B;
 }
 #section2, #section3 {
     background-color: #ABF7FF;
 }

 .wave{
     text-align: center;
     background: #01579B;

     position: relative;
 }
 .wave::before{
     content: "";
     position: absolute;
     left: 0;
     bottom: 0;
     right: 0;
     background-repeat: repeat-x;
     height: 10px;
     background-size: 20px 20px;
     background-image: radial-gradient(circle at 10px -5px, transparent 12px, #ABF7FF 13px);
 }
 .wave::after{
     content: "";
     position: absolute;
     left: 0;
     bottom: 0;
     right: 0;
     background-repeat: repeat-x;
     height: 15px;
     background-size: 40px 20px;
     background-image: radial-gradient(circle at 10px 15px, #ABF7FF 12px, transparent 13px);
 }



 /* .VueCarousel-navigation-button {
    text-indent: 1000em;
    } */

 /*
    Customisation des bouton next et previous du carousel :
    https://github.com/SSENSE/vue-carousel/issues/74
  */

 .VueCarousel-navigation-button {
     content: "";
     position: absolute;
     top: 8px;
     height: 35px;
     width: 25px;
 }

 .VueCarousel-navigation-next {
     background: url(../assets/ICONS/2x/baseline_arrow_forward_ios_black_18dp.png);
     right: 6px;
     margin-right:10px;
 }

 .VueCarousel-navigation-prev {
     background: url(../assets/ICONS/2x/baseline_arrow_back_ios_black_18dp.png);
     left: 6px;
     margin-left:10px;
 }



</style>
